import FullPageLoader from '@components/core/full-page-loader/full-page-loader';
import { getCobrandQueryOptions } from '@features/navigation/api/get-cobrand';
import { useThemeStore } from '@src/stores/theme-store';
import { GetCobrandResponse } from '@src/types/get-cobrand-response';
import { createFileRoute, redirect } from '@tanstack/react-router';
import React from 'react';
import DashboardLayout from './-layouts/dashboard-layout';

export const Route = createFileRoute('/_authenticated/dashboard')({
  component: DashboardLayout,
  beforeLoad: ({ location }) => {
    if (location.pathname === '/dashboard') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        from: location.pathname,
        to: './high-yield-savings',
      });
    }
  },
  wrapInSuspense: true,
  pendingComponent: () => {
    const partner = useThemeStore.use.partner();
    const data: GetCobrandResponse | undefined =
      Route.useRouteContext().queryClient.getQueryData(
        getCobrandQueryOptions({ partner }).queryKey,
      );
    return <FullPageLoader cobrandImage={data?.image} />;
  },
});
